module.exports = __webpack_public_path__ + "static/media/logoVenezuela.8fd9d8bc.png";